/* eslint-disable tailwindcss/no-arbitrary-value */
import React, { useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import proptypes from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { Card, CardTitle, Link, Typography } from '@one-thd/sui-atomic-components';
import {
  ArticleGuides as ArticleGuidesComponent
} from '@thd-olt-component-react/thd-recs-containers';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { getSvocId } from '../../utils';
import { HomepageContext } from '../context/HomepageContext';

const { number, string } = proptypes;

export function ArticleGuides({ REQUEST_KEY, id, guestUserId, slidesPer }) {
  const { channel } = useContext(ExperienceContext);
  const { defaultCardClass } = useContext(HomepageContext);

  const customerID = getSvocId() || guestUserId;

  return (
    <ErrorBoundary name="article-guides">
      <QueryProvider cacheKey="article-guides">
        <Card
          id={`article-guides-php-${id}`}
          className={defaultCardClass}
        >
          <CardTitle
            header={(
              <Typography variant="h3" weight="regular">
                DIY Guides For Your Projects
              </Typography>
            )}
            action={<Link href="/c/diy_projects_and_ideas">View All</Link>}
          />
          <ArticleGuidesComponent
            hideTitle
            requestKey={REQUEST_KEY}
            showLoading
            customerID={customerID}
            slidesPer={slidesPer}
            hideControls={channel === 'mobile'}
          />
        </Card>
      </QueryProvider>
    </ErrorBoundary>
  );
}

ArticleGuides.propTypes = {
  REQUEST_KEY: string,
  guestUserId: string,
  slidesPer: number,
  id: string,
};

ArticleGuides.defaultProps = {
  REQUEST_KEY: undefined,
  guestUserId: undefined,
  slidesPer: undefined,
  id: undefined,
};
